import styled from "styled-components";
import Image, {formatImageCMSData} from "@/components/common/Image";
import {getCssSizeValue, getHtmlFromRedactorField, getMapKey, isStringEmpty} from "@/utils/utils";
import {getButtonLinkData} from "@/components/common/Buttons/Button";
import LinkButton from "@/components/common/Buttons/LinkButton";
import {BUTTON_VARIANTS} from "@/constants";
import CornerBadge from "@/components/TilesModule/variants/TilesBlockImagesNavigation/CornerBadge";
import {useIsMobile} from "@/hooks/useDevice";
import {BREAKPOINTS} from "@/styles/themeSettings";

const Wrapper = styled.div`
    position: relative;
	//height: 100%;
    aspect-ratio: 477/375;
    @media (min-width: ${({theme}) => theme.breakpoints.tablet}px)  {
        aspect-ratio: unset;
    }
`

const StyledImage = styled(Image)`
    width: 100%;
    height: auto;
    aspect-ratio: ${({$aspectRatio}) => $aspectRatio};
`

const DataBar = styled.div`
    position: relative;
    z-index: 1;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: ${getCssSizeValue(20,BREAKPOINTS.MOBILE)} ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
    background: ${({theme}) => theme.colors.richBlue};
    color: ${({theme}) => theme.colors.platinum};
    display: flex;
    justify-content: space-between;
	flex-direction: column;
	gap: ${getCssSizeValue(8,BREAKPOINTS.MOBILE)};
	
    &.with-description {
        padding-top: ${getCssSizeValue(13, BREAKPOINTS.MOBILE)};
		.description{
            margin-bottom: ${getCssSizeValue(8, BREAKPOINTS.MOBILE)};
		}
    }
	
    .left-column {
        gap: inherit;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

    .button-container {
        display: flex;
        align-items: flex-end;
    }

    @media (min-width: ${({theme}) => theme.breakpoints.desktop}px) and (orientation: landscape) {
        position: absolute;
        padding: ${getCssSizeValue(16)};
        padding-left: ${getCssSizeValue(32)};
        gap: ${getCssSizeValue(8,BREAKPOINTS.DESKTOP)};
        flex-direction: row;

        &.with-description {
            padding-top: ${getCssSizeValue(32)};
            .description{
                margin-bottom: unset;
            }
        }
    }
`

const CornerBadgesContainer = styled.div`
	position: absolute;
    z-index: 2;
	display: flex;
	flex-direction: column;
	gap: ${getCssSizeValue(16)};
	top: ${getCssSizeValue(16)};
    right: ${getCssSizeValue(16)};
`

function getData(src) {
	return {
		header: src?.header || '',
		description: src?.description || '',
		image: formatImageCMSData(src?.image?.image || {}),
		cornerBadges: src?.cornerBadges || [],
		button: getButtonLinkData(src?.button)
	}
}

export default function SingleTile({tile}) {
	const {header, description, image, cornerBadges, button} = getData(tile)
	const renderDescription = !isStringEmpty(description)
	const isMobile = useIsMobile()

	return (
		<Wrapper className='col-desktop-8 col-tablet-4 col-mobile-8'>
			<StyledImage
				src={image.url}
				alt={image.alt}
				$aspectRatio={image.aspectRatio}
			/>
			<DataBar className={renderDescription ? 'with-description' : ''}>
				<div className='left-column'>
					{!isStringEmpty(header) && <div className='header typo-borna typo-borna-119'>{header}</div>}
					{renderDescription &&
						<div
							className='description typo-strawford typo-strawford-46'
							dangerouslySetInnerHTML={getHtmlFromRedactorField(description)}
						/>
					}
				</div>
				<div className='button-container'>
					<LinkButton {...button} variant={BUTTON_VARIANTS.TERTIARY}/>
				</div>
			</DataBar>
			{!isMobile && (
				<CornerBadgesContainer>
					{cornerBadges.map((badge, index) => <CornerBadge key={getMapKey(badge, index)} badge={badge} />)}
				</CornerBadgesContainer>
			)}
		</Wrapper>
	)
}
